import React, { useState } from 'react';

export const BodyInfoSection = _ => {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [userProfile, setUserProfile] = useState(() => {
        const saved = localStorage.getItem('logup_user_profile');
        return saved ? JSON.parse(saved) : { age: '', height: '', weight: '', muscleMass: '', bodyFat: '', lastUpdated: '' };
    });

    const handleProfileChange = (field, value) => {
        const today = new Date();
        const dateString = `${today.getFullYear()}.${String(today.getMonth() + 1).padStart(2, '0')}.${String(today.getDate()).padStart(2, '0')}`;
        
        const nextProfile = { 
            ...userProfile, 
            [field]: value,
            lastUpdated: dateString
        };
        
        setUserProfile(nextProfile);
        localStorage.setItem('logup_user_profile', JSON.stringify(nextProfile)); // 로컬 스토리지에 함께 저장
    };

    return (
        <section className='ml-4 mr-4'>
            <div className="flex items-center gap-2 mb-4 px-1">
                <span className="bg-sky-500 text-white text-[10px] font-black px-2 py-0.5 rounded-md tracking-wider">00</span>
                <h3 className="text-lg font-black text-slate-800 tracking-tight">신체 정보</h3>
            </div>
            <div className="card p-5 bg-white rounded-3xl shadow-sm border border-slate-100">
                <button 
                    onClick={() => setIsProfileOpen(!isProfileOpen)}
                    className="w-full flex items-center justify-between text-sm font-bold text-slate-700 transition-colors"
                >
                    <span className="flex items-center gap-2">
                        <span className="material-icons-round text-sky-500">person</span>
                        신체 및 체성분 정보 입력
                    </span>
                    <span className="material-icons-round text-slate-400">
                        {isProfileOpen ? 'expand_less' : 'expand_more'}
                    </span>
                </button>
                
                {isProfileOpen && (
                    <div className="mt-5 space-y-4 animate-fadeIn">
                        <div className="flex gap-3">
                            <div className="relative flex-1">
                                <input type="number" inputMode="numeric" value={userProfile.age || ''} onChange={(e) => handleProfileChange('age', e.target.value)} placeholder="나이" className="w-full bg-slate-50 text-slate-800 text-sm font-bold rounded-xl px-3 py-2.5 border border-slate-200 outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 transition-all text-center" />
                                <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">세</span>
                            </div>
                            <div className="relative flex-1">
                                <input type="number" inputMode="decimal" value={userProfile.height || ''} onChange={(e) => handleProfileChange('height', e.target.value)} placeholder="키" className="w-full bg-slate-50 text-slate-800 text-sm font-bold rounded-xl px-3 py-2.5 border border-slate-200 outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 transition-all text-center" />
                                <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">cm</span>
                            </div>
                            <div className="relative flex-1">
                                <input type="number" inputMode="decimal" value={userProfile.weight || ''} onChange={(e) => handleProfileChange('weight', e.target.value)} placeholder="몸무게" className="w-full bg-slate-50 text-slate-800 text-sm font-bold rounded-xl px-3 py-2.5 border border-slate-200 outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 transition-all text-center" />
                                <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">kg</span>
                            </div>
                        </div>
                        <div className="flex gap-3">
                            <div className="relative flex-1">
                                <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">골격근량</span>
                                <input type="number" inputMode="decimal" value={userProfile.muscleMass || ''} onChange={(e) => handleProfileChange('muscleMass', e.target.value)} placeholder="골격근량" className="w-full bg-slate-50 text-slate-800 text-sm font-bold rounded-xl px-3 py-2.5 border border-slate-200 outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 transition-all text-center" />
                                <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">kg</span>
                            </div>
                            <div className="relative flex-1">
                                <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">체지방량</span>
                                <input type="number" inputMode="decimal" value={userProfile.bodyFat || ''} onChange={(e) => handleProfileChange('bodyFat', e.target.value)} placeholder="체지방량" className="w-full bg-slate-50 text-slate-800 text-sm font-bold rounded-xl px-3 py-2.5 border border-slate-200 outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 transition-all text-center" />
                                <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-bold text-slate-400">kg</span>
                            </div>
                        </div>

                        <div className="space-y-1.5 pt-1">
                            <p className="text-[11px] font-bold text-slate-400 flex items-start gap-1 leading-relaxed">
                                <span className="material-icons-round text-[14px] mt-0.5 shrink-0">info</span>
                                <span>
                                    사용자 기기에만 저장되어 수집되지 않으며 운동 기록 분석 시 활용됩니다.<br/>
                                    <span className="text-slate-500">2 ~ 4주 간격으로 운동 전 검사하여 입력하는 것을 추천합니다.</span>
                                </span>
                            </p>
                            {userProfile.lastUpdated && (
                                <p className="text-[10px] font-black text-sky-500 ml-4 pt-1">
                                    마지막 업데이트: {userProfile.lastUpdated}
                                </p>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};